import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import React, { createContext, useContext } from "react";

type GeneralContextType = {
  isHeaderVisible: boolean;
  setIsHeaderVisible: (visible: boolean) => void;
  isOriginModalVisible: boolean;
  setIsOriginModalVisible: (visible: boolean) => void;
  isDestinationModalVisible: boolean;
  setIsDestionationModalVisible: (visible: boolean) => void;
  isSERP: boolean;
  isOpenOriginCalendar: boolean;
};

const GeneralContext = createContext<GeneralContextType | undefined>(undefined);

export const GeneralProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const location = useLocation();

  const [isHeaderVisible, setIsHeaderVisible] = useState(true);
  const [isOriginModalVisible, setIsOriginModalVisible] = useState(false);
  const [isDestinationModalVisible, setIsDestionationModalVisible] =
    useState(false);
  const [isSERP, setIsSERP] = useState(false);
  const [isOpenOriginCalendar, setIsOpenOriginCalendar] = useState(false);

  useEffect(() => {
    const path = location.pathname;
    const searchParams = new URLSearchParams(location.search);

    // isSERP
    const match = path.match(
      /^\/passagens-aereas-de-([^/]+)\/([^/]+)\/para-([^/]+)\/([^/]+)$/,
    );
    const hasQueryParams = searchParams.has("origin-airport");
    setIsSERP(!!(match && hasQueryParams));

    // open-origin-calendar
    const hasOpenParam = searchParams.has("open-origin-calendar");
    const openValue = searchParams.get("open-origin-calendar");

    const origin = searchParams.get("origin-airport");
    const destination = searchParams.get("destination-airport");
    const adults = Number(searchParams.get("quantity-of-adults"));
    const children = Number(searchParams.get("quantity-of-children"));
    const babies = Number(searchParams.get("quantity-of-babies"));

    const isValidSearch =
      !!origin && !!destination && adults > 0 && children >= 0 && babies >= 0;

    const shouldOpen =
      hasOpenParam &&
      (openValue === "" || openValue === "true") &&
      isValidSearch;

    setIsOpenOriginCalendar(shouldOpen);
  }, [location.pathname, location.search]);

  return (
    <GeneralContext.Provider
      value={{
        isHeaderVisible,
        setIsHeaderVisible,
        isOriginModalVisible,
        setIsOriginModalVisible,
        isDestinationModalVisible,
        setIsDestionationModalVisible,
        isSERP,
        isOpenOriginCalendar,
      }}
    >
      {children}
    </GeneralContext.Provider>
  );
};

export const useGeneralContext = () => {
  const context = useContext(GeneralContext);
  if (!context) {
    throw new Error("useGeneralContext must be used within a GeneralProvider");
  }
  return context;
};
